import {Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';

import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {InboxModel} from '../../models/api/inboxModel';
import {SettingsFieldLine} from '../common/settingsFieldLine';
import {SettingsInboxMassArchiveDialog} from './settingsInboxMassArchiveDialog';

/*
 * Props.
 */

interface SettingsInboxesMassArchiveProps {
  inbox: InboxModel;
}

/*
 * Component.
 */

export const SettingsInboxesMassArchive: FC<SettingsInboxesMassArchiveProps> = (props) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const maybeRenderDialog = () => {
    if (!isDialogOpen) {
      return null;
    }
    return (
      <SettingsInboxMassArchiveDialog onRequestClose={() => setIsDialogOpen(false)} inbox={props.inbox} />
    );
  };

  return (
    <>
      {maybeRenderDialog()}
      <SettingsFieldLine
        title={<Trans id="settingsinboxes-massarchive-fieldtitle">Archive all conversations</Trans>}
        subtitle={
          <Trans id="settingsinboxes-massarchive-fieldsubtitle">
            All conversations before a certain date will be archived.
          </Trans>
        }
        content={
          <Button variant={ButtonVariantsEnum.SECONDARY} onClick={() => setIsDialogOpen(true)}>
            <Trans id="settingsinboxes-massarchive-button">Archive from...</Trans>
          </Button>
        }
      />
    </>
  );
};
